"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
const axios_1 = __importDefault(require("axios"));
const token_1 = require("./token");
const user_1 = require("./user");
/**
 * Авторизация
 * @param email
 * @param password
 */
const auth = (email, password) => {
    return (0, axios_1.default)({
        method: 'post',
        url: '/auth',
        data: { email, password },
    }).then((response) => {
        (0, token_1.saveToken)({
            accessToken: response.data.accessToken,
            refreshToken: response.data.refreshToken,
            expiresIn: response.data.expiresIn,
        });
        (0, user_1.saveUserLS)(response.data.user);
        return response;
    });
};
exports.auth = auth;
